<template>
<b-button :variant="variant" @click="click()">
  <p-spinner v-show="status === 'loading'" />
  <b-icon v-if="status === 'done'" icon="check" aria-hidden="true"></b-icon>
  <b-icon v-if="status === 'error'" icon="x" aria-hidden="true"></b-icon>
  {{text}}
</b-button>
</template>

<script>

export default {
  name: 'poss-button',
  props: {
    text: { type: String, required: true },
    action: { type: Function, required: true },
    arguments: { type: Array, required: false, default: () => [] },
    variant: { type: String, required: false }
  },
  data () {
    return {
      status: null,
      statusTimer: null
    }
  },
  created: async function () {
  },
  methods: {
    setStatus (status) {
      clearTimeout(this.statusTimer)
      this.status = status
      this.statusTimer = setTimeout(() => {
        this.status = null
      }, 1000 * 3)
    },
    async click () {
      this.setStatus(null)
      this.status = 'loading'
      try {
        await this.action(...this.arguments)
        this.setStatus('done')
      } catch (e) {
        this.setStatus('error')
        throw e
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/POSSButton.vue